import { render, staticRenderFns } from "./FormTypePiece.vue?vue&type=template&id=41d7a6ce"
import script from "./FormTypePiece.vue?vue&type=script&lang=js"
export * from "./FormTypePiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports